import type { MutationOptions } from '@tanstack/react-query';
import { QueryClient as BaseQueryClient } from '@tanstack/react-query';

export class QueryClient extends BaseQueryClient {
  createMutation<TData, TError, TVariables, TOnMutateResult>(
    options: MutationOptions<TData, TError, TVariables, TOnMutateResult>,
  ) {
    return this.getMutationCache().build(this, options);
  }

  mutate <TData, TError, TVariables, TOnMutateResult>(
    options: MutationOptions<TData, TError, TVariables, TOnMutateResult>,
    variables: TVariables,
  ) {
    const mutation = this.createMutation(options);
    mutation.execute(variables);
  }

  async mutateAsync<TData, TError, TVariables, TOnMutateResult>(
    options: MutationOptions<TData, TError, TVariables, TOnMutateResult>,
    variables: TVariables,
  ) {
    return new Promise((resolve, reject) => {
      this.mutate({
        ...options,
        onSuccess: (...args) => {
          options?.onSuccess?.(...args);
          resolve(args);
        },
        onError: (...args) => {
          options?.onError?.(...args);
          reject(args);
        },
      }, variables);
    });
  }
}

export const queryClient = new QueryClient();

// TypeScript only:
declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__:
    import('@tanstack/query-core')
    .QueryClient;
  }
}

window.__TANSTACK_QUERY_CLIENT__ = queryClient;
